<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start">
                <strong>{{$t('components.warehouseMembers')}} ({{place_name}})</strong>
              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>

              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CForm>

              <CCol sm="6" md="4">
                <CRow>
                  <CCol sm="12">
                    <treeselect
                            v-model="document_person"

                            :async="true"
                            :load-options="load_persons"
                            :placeholder="$t('search')"
                            :normalizer="normalizer_persons"
                    />

                  </CCol>
                </CRow>

              </CCol>


            </CForm>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6">
        <CCard>
          <CCardHeader>
            <strong>{{$t('components.warehouseMembersList')}}</strong>
          </CCardHeader>
          <CCardBody>
            <CDataTable
                    :items="items"
                    :fields="fields"

                    :items-per-page="20"
                    hover
                    sorter
                    pagination
            >
              <template #row="{item}">

                <td>
                  <p >{{item.row_id+1}}</p>

                </td>

              </template>
              <template #user="{item}">

                <td>
                  <p >{{item.memberName}}</p>

                </td>

              </template>




              <template #operation="{item}">
                <td >

                  <CButton
                          class="mr-1"

                          square
                          size="sm"
                          :title="$t('buttons.delete')"

                          @click="delete_item_dialog(item)"
                  ><CIcon size="sm" class="text-danger" name="cilTrash"/>
                  </CButton>
                </td>
              </template>



            </CDataTable>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
  import axios from "axios";
  import  { bus } from "../../../main";
  import Treeselect from "@riophae/vue-treeselect";
  // import the styles
  import "@riophae/vue-treeselect/dist/vue-treeselect.css";
  import {ASYNC_SEARCH} from "@riophae/vue-treeselect";
  var simulateAsync=null
  const simulateAsyncOperation = fn => {
    if(simulateAsync!=null){
      clearTimeout(simulateAsync)
    }
    simulateAsync =  setTimeout(fn, 1000)
  }
  var items = [

  ];

  export default {
    name: "Login",
    components: {
      Treeselect,

    },
    data() {
      return {
        name: '',
        code: '',
        file: '',
        color: '#ffffff',
        previewImage: '',
        description: '',
        document_person: null,
place_name:'',
        items: items.map((item, row_id) => { return {...item, row_id};}),
        fields : [
          { key: 'row',label:this.$t('tables.row'),sorter:false, _style:'width:3%' },
          { key: 'user',label:this.$t('tables.name'), _style:'width:12%' },
          { key: 'jobTitle',label:this.$t('jobTitle'), _style:'width:12%' },
          { key: 'operation',label:this.$t('tables.operation'), _style:'width:5%;' },


        ],
        details: [],
        collapseDuration: 0,
        status_form:0,
        load_persons({action, searchQuery, callback}) {

          if (action === ASYNC_SEARCH) {
            simulateAsyncOperation(() => {
              let options;
              const formData = new FormData();

              formData.append('SearchTxt', searchQuery);

              axios.post('GetUsers', formData, {show_pros:true}).then(function (response) {
                options = response.data.data;

                callback(null, options);

                // localStorage.setItem("api_token", response.data.access_token);
                // self.$router.push({ path: 'notes' });
              })
                      .catch(function (error) {
                        console.log(error);
                      });


              //  const options = this.get_keywords(searchQuery);
              // const options = [1, 2, 3, 4, 5].map(i => ({
              //     id: `${searchQuery}-${i}`,
              //     name: `${searchQuery}-${i}`,
              // }))

            })
          }
        },
        normalizer_persons(node) {
          return {
            id: node.userId,
            label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
          };
        },
      };
    },mounted() {
      this.$root.root_validate_errors = [];
this.get_places();
      this.get_lists();
      bus.$on(this.confirm_delete_name, (data) => {
         // alert(data);
         if(data== "true"){
           this.delete_item();

         }else{
            this.status_form = 0;
         }
      });
    },
    watch: {
      '$route.params.place_id': function () {
        this.get_lists();
      }
    },
    methods: {
      get_places() {
        var self = this;

        const formData = new FormData();


        // formData.append('id', this.selected_province);


        axios.post('GetPlaces', formData, {}).then(function (response) {

          var content_data = response.data;

          // items = content_cats.orders;
          if (content_data.statusCode == 0) {

            self.place_name = content_data.data.filter(x=>x.id == self.$route.params.place_id)[0].placeName;
          } else {
            self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

          }


        })
                .catch(function (error) {

                  console.log(error);
                });

      },

      validateForm: function () {
        this.$root.root_validate_errors = [];

        if (this.document_person != null ) {
          return true;
        }


        if (this.document_person == null) {
          this.$root.root_validate_errors.push(this.$t('dialogs.selectWarehouseMember'));
        }


        return false;
        // e.preventDefault();
      },
      get_style(color) {
        return {
            backgroundColor: color

        };
      },
      edit_item(item) {
        // this.$set(this.items[item.id], '_toggled', !item._toggled)
        this.name = item.placeName;
        this.code = item.placeCode;
        // this.description = item.description;
        // this.previewImage = item.image;
        this.status_form = item.id;
        // this.$nextTick(() => {
        //     this.collapseDuration = 0
        // })
      } ,
      emptyList() {
        // this.$set(this.items[item.id], '_toggled', !item._toggled)
        this.name = '';
        this.code = '';
        // this.description = '';
        // this.previewImage = '';
        this.status_form = 0;

        // this.$nextTick(() => {
        //     this.collapseDuration = 0
        // })
      },
      get_lists(){
        var self = this;
        console.log("route id "+this.$route.params.cat_id);

        const formData = new FormData();


        formData.append('Id', this.$route.params.place_id);


        axios.post(  'GetPlaceMembers',formData,{

        }).then(function (response) {

          var content_data = response.data;

          // items = content_cats.orders;
          if(content_data.statusCode==0){
            self.items =  content_data.data.map((item, row_id) => { return {...item, row_id};});
          }else{
            self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"),content_data.message);

          }


        })
                .catch(function (error) {

                  console.log(error);
                });

      },
      goSubCategories(item,index){

        this.$router.push({ path: '/categories/'+this.items[index].id});
// this.get_categories();
        // this.$router.push({ path: '/posts/'});
      },
      place_users(item){

        this.$router.push({ path: '/dashboard/places/users/'+item.id});
// this.get_categories();
        // this.$router.push({ path: '/posts/'});
      },
      insert_data() {
        if (!this.validateForm()) {
          console.log("validate form is false"+this.validate_errors);
          return true;
        }

        let self = this;
        const formData = new FormData();
        let url;
        if(this.status_form==0){
          url = "AddPlaceMember";
        }else{
          url = "EditPlace";
          formData.append('id', this.status_form);
        }

        formData.append('MemberId', this.document_person);
        formData.append('PlaceId', this.$route.params.place_id);
        axios.post(url, formData, {
        }).then((res) => {




            self.status_form=0;
            self.name = '';
            self.code = '';
            self.get_lists();
          self.$root.modal_component.show_api_response_modals(res);


        })
                .catch(function (error) {

                  console.log(error);
                });

      },
      delete_item_dialog(item) {
        this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"),this.$t("dialogs.deleteMessage"),[this.$t("dialogs.ok")],this.confirm_delete_name);

        this.status_form = item.id;

      },
      delete_item(){


        let self = this;
        const formData = new FormData()
        let url;
        url = "DeletePlaceMember";


        formData.append('Id', this.status_form);

        axios.post(url, formData, {
        }).then((res) => {

          self.$root.modal_component.show_api_response_modals(res);

          self.status_form=0;

          self.get_lists();


        })
                .catch(function (error) {

                  console.log(error);
                });
// this.get_categories();
        // this.$router.push({ path: '/posts/'});
      },
    }
  };

</script>
